module.exports = __webpack_public_path__ + "static/img/fclab-folder.3f874cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fclab-folder.jpg
// module id = F9r0
// module chunks = 0